import { useMutation } from "react-query";
import axios from "libs/axios";
import { MutationConfig } from "libs/react-query";
import { status, statusDetail } from "interface";
interface userNamePasswordRequest {
  username: string;
  password: string;
}
interface userNamePasswordResponse {
  data: {
    id: string;
    phoneNumber: string;
    roles: string;
    jwToken: string;
    status: status;
    statusDetail: statusDetail;
  };
  succeeded: true;
  message: string;
}
const userNamePassword = async ({
  data,
}: {
  data: userNamePasswordRequest;
}) => {
  return await axios
    .post<userNamePasswordResponse>("/api/Account/login", data)
    .then((res) => res.data);
};
type LoginOptions = {
  config?: MutationConfig<typeof userNamePassword>;
};
export const useMerchantNamePassword = ({ config }: LoginOptions) => {
  return useMutation({
    ...config,
    mutationFn: userNamePassword,
  });
};
